import React from "react";

const GLogo = () => {
  return (
    <svg
      width="98px"
      height="98px"
      viewBox="0 0 98 98"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>634CF4F4-100C-4069-9D1D-DB659049A2A2</title>
      <desc>Created with sketchtool.</desc>
      <defs>
        <polygon
          id="path-1"
          points="0 42.5969045 39.9097725 42.5969045 39.9097725 0.0434381755 0 0.0434381755"
        />
      </defs>
      <g
        id="Invision"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Loaders" transform="translate(-241.000000, -637.000000)">
          <g id="Content-block" transform="translate(200.000000, 408.000000)">
            <g
              id="Large/Tango/Standard"
              transform="translate(42.000000, 230.000000)"
            >
              <g id="Group">
                <g id="Oval" stroke="#194fa1" strokeWidth="2">
                  <g id="Oval-group{:linearEase;0,4,4,190,190,360,1;20,4,4,190,190,719,1;}">
                    <circle
                      id="Oval"
                      strokeOpacity="0.5"
                      cx="48"
                      cy="48"
                      r="48"
                    />
                    <path
                      d="M96,48 C96,21.4933333 74.5066667,0 48,0"
                      id="Shape"
                    />
                  </g>
                </g>
                {/* <g id="G" transform="translate(29.838596, 26.666667)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="path-1" />
                  <path
                    d="M20.7293173,42.6134 C9.29852744,42.6134 0,33.0652491 0,21.3281441 C0,9.59241379 9.29852744,0.0434381755 20.7293173,0.0434381755 C21.6449799,0.0434381755 22.3868809,0.807180272 22.3868809,1.7493488 C22.3868809,2.68904299 21.6449799,3.45223525 20.7293173,3.45223525 C11.1293173,3.45223525 3.31941099,11.4731768 3.31941099,21.3281441 C3.31941099,31.1844861 11.1293173,39.2040531 20.7293173,39.2040531 C21.6449799,39.2040531 22.3868809,39.9669704 22.3868809,40.9099637 C22.3868809,41.8496579 21.6449799,42.6134 20.7293173,42.6134 Z M38.2281125,29.7928149 C36.9847389,29.7922651 36.5726907,27.9395443 36.5726907,27.9359704 C35.8864792,25.4201302 34.7402944,23.6259686 33.2508701,22.7368606 C32.1402944,22.0734662 31.2556893,22.1226778 31.1726907,22.1237775 C31.1202141,22.1246023 21.6698795,22.1248772 21.6698795,22.1248772 C20.7523427,22.1243274 20.0091031,21.3614101 20.0096386,20.4195165 C20.010174,19.4787226 20.7534137,18.7163551 21.6709505,18.7169049 L30.9962517,18.7210288 C31.8902275,18.6759411 37.5598395,18.7185545 39.8305221,27.2426091 C40.1378848,28.3986693 39.5427043,29.8219571 38.2281125,29.7928149 Z"
                    id="Combined-Shape"
                    fill="#E0772C"
                    fillRule="nonzero"
                    mask="url(#mask-2)"
                  />
                </g> */}
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default GLogo;
